<template>
  <div class="social-bar-container">
    <div class="social-bar-wrapper">
      <button v-if="user.is_guest" class="social-bar-button" @click="login()">
        <i class="svg fas fa-user-circle"></i>
        <span>{{ $t("login") }}</span>
      </button>

      <button v-if="user.is_guest" class="social-bar-button" @click="login()">
        <i class="svg fas fa-save"></i>
        <span>{{ $t("save") }}</span>
      </button>

      <button class="social-bar-button" @click="goFriends">
        <i class="svg fas fa-user-friends"></i>
        <span>{{ $t("friends") }}</span>
      </button>

      <button
        class="social-bar-button"
        v-for="sb in shopButtons"
        :key="sb"
        @click="goShop(sb)"
      >
        <i class="svg fas fa-plus-circle shop-plus"></i>
        <img :src="sb" id="gdplusShop" />
        <span>{{ $t("shop") }}</span>
      </button>

      <button class="social-bar-button" @click="goSettings">
        <i class="svg fas fa-cog"></i>
        <span>{{ $t("settings") }}</span>
      </button>
      <button class="social-bar-button" @click="goNotificatons">
        <span
          v-if="!user.is_guest && unseenNotificationCount !== 0"
          class="badge badge-notify"
          >{{ unseenNotificationCount }}</span
        >
        <i class="svg fas fa-bell fa-blink"></i>

        <span>{{ $t("notification_title") }}</span>
      </button>

      <div v-if="!game.inGameSupport">
        <button
          v-if="supportButtons.faq"
          class="social-bar-button"
          @click="goFAQ(supportButtons.faq)"
        >
          <i class="svg fas fa-question-circle"></i>
          <span>{{ $t("faq") }}</span>
        </button>

        <button class="social-bar-button" @click="goHelp">
          <i class="svg fas fa-life-ring"></i>
          <span>{{ $t("help") }}</span>
        </button>
      </div>

      <button class="social-bar-button" @click="toggleFullscreen">
        <i class="svg fas fa-expand-arrows-alt"></i>
        <span>{{ $t("expand") }}</span>
      </button>

      <button
        v-if="!user.is_guest && !isSSO"
        class="social-bar-button"
        @click="logout"
      >
        <i class="svg fas fa-sign-out-alt"></i>
        <span>{{ $t("logout") }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import EventBus from "../core/EventBus";
import { getKeyOfValue, appendQueryParam } from "../core/utils/index";

export default {
  name: "SocialBar",
  props: {
    locale: String
  },
  methods: {
    logout() {
      this.$store.dispatch("logoutUser", true);
    },
    login() {
      this.eventBus.broadcast("USER_LOGIN_PROMPT");
    },
    goFriends() {
      if (this.user.is_guest) {
        this.login();
        return;
      }
      this.$emit("toggle");
      this.eventBus.broadcast("GAME_FRIENDS_MANAGEMENT");
    },
    goSettings() {
      if (this.user.is_guest) {
        this.login();
        return;
      }
      this.$emit("toggle");
      this.eventBus.broadcast("GAME_SETTINGS_MANAGEMENT");
    },
    goNotificatons() {
      if (this.user.is_guest) {
        this.login();
        return;
      }
      this.$emit("toggle");
      this.eventBus.broadcast("GAME_NOTIFICATIONS");
    },
    toggleFullscreen() {
      this.$emit("toggle");
      this.eventBus.broadcast("GAME_TOGGLE_FULLSCREEN");
    },
    goHelp() {
      this.$emit("toggle");
      const vm = this;

      new Promise(resolve => {
        if (vm.supportButtons.faq)
          vm.$bvModal
            .msgBoxConfirm(vm.$t("faq_popup_text"), {
              title: vm.$t("faq_popup_title"),
              modalClass: "last-delete-account",
              size: "md",
              buttonSize: "sm",
              okVariant: "",
              cancelVariant: "primary",
              okTitle: vm.$t("faq_popup_button_submit"),
              cancelTitle: vm.$t("faq_popup_button_faq"),
              footerClass: "p-2 btn-group",
              hideHeaderClose: false,
              centered: true
            })
            .then(confirmed => resolve(confirmed))
            .catch(() => resolve(false));
        else {
          resolve(true);
        }
      })
        .then(confirmed => {
          if (confirmed) {
            // If there is an external help link, use it.
            // Otherwise, use our zendesk submit form
            const helpLink = vm.supportButtons.help;
            if (helpLink) {
              const link = appendQueryParam(
                helpLink,
                "locale",
                vm.$store.getters.getLocale
              );
              return window.open(link, "_blank");
            }
            return vm.eventBus.broadcast("USER_SUPPORT_REQUEST");
          } else if (confirmed === false) {
            vm.pending = false;
            vm.goFAQ(vm.supportButtons.faq);
          }
        })
        .catch(err => {
          console.log(err.message);
          vm.pending = false;
        });
    },
    goFAQ(url) {
      this.$emit("toggle");

      const link = appendQueryParam(
        url,
        "locale",
        this.$store.getters.getLocale
      );
      window.open(link, "_blank");
    },
    goShop(sb) {
      if (this.user.is_guest) {
        this.login();
        return;
      }

      const vcurrency = getKeyOfValue(this.shopButtons, sb);
      this.eventBus.broadcast("GAME_STANDARD_SHOP", vcurrency);
    }
  },
  data() {
    return {
      isLoggedIn: this.$store.getters.isLoggedIn,
      isSSO: this.$store.getters.isSSO,
      user: this.$store.getters.getUser,
      game: this.$store.getters.getGame,
      shopButtons: this.$store.getters.getGame.shopButtons || {},
      supportButtons: this.$store.getters.getGame.supportButtons || {},
      eventBus: new EventBus()
    };
  },
  computed: {
    unseenNotificationCount() {
      return this.$store.getters.unseenNotificationCount;
    }
  },
  mounted() {
    this.eventBus.subscribe("USER_LOGOUT", this.logout);
  }
};
</script>
